import { AdditionalCostRestEndpointService } from '@api'
import { endOfDay, format } from 'date-fns'
import { useQuery } from 'react-query'

import { handleError } from '@/utils/error'

interface UseAccountingAdditionalCostsParams {
  from?: Date
  to?: Date
  page: number
  size: number
}

export function useAccountingAdditionalCosts({
  from,
  to,
  page,
  size,
}: UseAccountingAdditionalCostsParams) {
  const {
    data: additionalCosts,
    isLoading,
    isError,
    refetch,
    isSuccess,
  } = useQuery(
    ['additional-costs', from, to, page, size],
    () => {
      if (!from || !to) {
        return
      }

      return AdditionalCostRestEndpointService.dashboardGetAdditionalCosts({
        from: format(from, "yyyy-MM-dd'T'HH:mm:ss"),
        to: format(endOfDay(to), "yyyy-MM-dd'T'HH:mm:ss"),
        pageable: {
          page,
          size,
        },
      })
    },
    {
      onError: (error) =>
        handleError(error, 'Failed to get additional costs', refetch),
    },
  )

  return {
    additionalCosts,
    isLoading,
    isError,
    isSuccess,
    refetch,
  }
}
